import { Box } from '@primer/react';
import Hero from '../components/Hero';
import TrustedBy from '../components/TrustedBy';
import CaseResults from '../components/CaseResults';
import Industries from '../components/Industries';
import Expertise from '../components/Expertise';
import ConsultationCTA from '../components/ConsultationCTA';
import SEO from '../components/SEO';

function Home() {
  return (
    <Box sx={{ backgroundColor: 'canvas.default' }}>
      <SEO
        title="UX Design Agency in Dallas, TX | Enterprise, FinTech & AI"
        description="Pegasus UX is a Dallas, TX UX design agency and UX consulting company offering SaaS UX design, fintech UX design, enterprise UX consulting, AI UX design, and UX audits. Trusted by GitHub, McKinsey, Verizon & State Farm."
        keywords="ux agency dallas, dallas ux design agency, ux design agency dallas tx, dallas ui ux design company, product design agency dallas, best ux agency in dallas, ui ux design company, ui ux design agency, ui ux design firm, ux consulting companies, best ux design agencies, best ux companies, experience design services, saas ux design, saas ui ux design, saas ui design, fintech ux design, ai ux design, web app ux design, enterprise ux, enterprise user experience, ux for enterprise applications, logistics ux design, ux audit company, ux testing services, ui design consultants"
        path="/"
      />
      <Hero />
      <TrustedBy />
      <CaseResults />
      <Industries />
      <Expertise />
      <ConsultationCTA />
    </Box>
  );
}

export default Home;
